<!-- 文本输入框 -->
<template>
  <div class="text" v-if="currentUser">
    <div class="emoji">
      <div class="elround">
        <img src="@/assets/img3.png" class="img3" />
        <input type="file" accept="image/*" class="pic" @change="onInputChange" id="imagePicker" />
      </div>
      <img src="@/assets/img4.png" class="img4" @click="handleTransfer" />
    </div>
    <textarea ref="text" v-model="content" @keyup="onKeyup" />
    <div class="send">
      <span @click="sendTextMessage()">发送</span>
      <span class="end" @click="handleEnd">结束会话</span>
    </div>
    <transition name="appear">
      <div v-show="warn" class="warn">
        <div class="description">不能发送空白信息</div>
      </div>
    </transition>
    <session-archiv-vue ref="sessionArchivVue" :currentUser="currentUser" @created="onConversationEnded" />
    <transfer-vue :currentUser="currentUser" ref="transferVue" />
  </div>
</template>

<script>
import sessionArchivVue from '../other/sessionArchiv.vue'
import transferVue from '../other/transfer.vue'
import { spaceTime } from '@/utils/index'
export default {
  components: { sessionArchivVue, transferVue },
  props: ['serviceInfo'],
  data() {
    return {
      currentUser: null,
      applyHover: false,
      content: '',
      hint: true,
      reply: '未找到',
      frequency: 0,
      warn: false,
      showEmoji: false,
      showReply: false,
      // 话术
      docAutoAnswers: [],
      drawer: false,
      direction: 'ltr',
      input2: '',
      activeNames: ['1'],
    }
  },
  watch: {
    // 在选择其它对话的时候 聚焦输入框
    selectId() {
      setTimeout(() => {
        this.$refs.text.focus()
      }, 0)
    },
    // 当输入框中的值为空时 弹出提示  并在一秒后消失
    content() {
      if (this.content === '') {
        this.hint = true
        if (this.frequency === 0) {
          this.warn = true
          this.frequency++
          setTimeout(() => {
            this.warn = false
          }, 1000)
        }
      } else {
        this.hint = false
      }
    }
  },
  // 在进入的时候 聚焦输入框
  mounted() {
    if (this.currentUser) {
      this.$refs.text.focus()
    }
  },
  created() {
    this.$EventBus.$on('handleChatList', (row) => {//监听事件
      this.currentUser = row;
    })
  },
  methods: {
    // 按回车发送信息
    onKeyup(e) {
      if (e.keyCode === 13) {
        this.sendTextMessage()
      }
    },
    sendTextMessage() {
      let content = "";
      content = this.content;
      if (!content) return;
      this.$EventBus.$emit('brotherSendMessge', content)
      this.content = ''
    },
    handleEnd() {
      this.$refs.sessionArchivVue.handleShow()
    },
    // 归档成功后统一广播：消息流清空当前会话、会话列表重拉。
    // 原来 sessionArchiv 虽然 $emit('created')，但这里没监听，归档完界面一动不动。
    onConversationEnded() {
      this.content = ''
      this.$EventBus.$emit('csConversationEnded')
    },
    handleTransfer() {
      this.$refs.transferVue.handleShow(this.serviceInfo)
    },
    save(params) {
      this.$emit('save', params)
    },
    //发送图片消息
    onInputChange(e) {
      this.$EventBus.$emit('onInputChange', 'imagePicker')

    },
  }
}
</script>

<style lang="scss" scoped>
.text {
  // position: relative;
  height: 200px;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  background: #fff;
  border-top: 1px solid rgba(197, 197, 197, 0.8);
  ::v-deep .btn-wrapper-simple {
    height: 100%;
    line-height: 20px;
  }

  ::v-deep .child-ul-wrapper {
    max-height: 150px;
    overflow: scroll;
  }

  ::v-deep .nav-name-right {
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 200px;
  }

  ::v-deep .el-drawer__header {
    margin-bottom: 0px;
  }

  .emoji {
    position: relative;
    width: 100%;
    height: 40px;
    line-height: 40px;
    font-size: 12px;
    padding: 9px 18px;
    box-sizing: border-box;
    color: #7c7c7c;
    .img4,
    .img3 {
      width: 27px;
      height: 27px;
      cursor: pointer;
    }

    .elround {
      padding-right: 10px;
      display: inline-block;
      position: relative;
    }

    input.pic {
      position: absolute;
      height: 27px;
      display: inline-block;
      width: 27px;
      border-radius: 10px;
      opacity: 0;
      left: 0;
      cursor: pointer;
    }

    .emojiBox {
      position: absolute;
      display: flex;
      flex-wrap: wrap;
      top: -210px;
      left: -100px;
      width: 300px;
      height: 200px;
      padding: 5px;
      background-color: #fff;
      border: 1px solid #d1d1d1;
      border-radius: 2px;
      box-shadow: 0 1px 2px 1px #d1d1d1;

      &.showbox-enter-active,
      &.showbox-leave-active {
        transition: all 0.5s;
      }

      &.showbox-enter,
      &.showbox-leave-active {
        opacity: 0;
      }
    }

    .emojiBox1 {
      position: absolute;
      display: flex;
      flex-wrap: wrap;
      top: -210px;
      left: -100px;
      width: 300px;
      height: 200px;
      padding: 5px;
      border-radius: 2px;

      &.showbox-enter-active,
      &.showbox-leave-active {
        transition: all 0.5s;
      }

      &.showbox-enter,
      &.showbox-leave-active {
        opacity: 0;
      }
    }
  }

  textarea {
    box-sizing: border-box;
    padding: 0 20px;
    height: 110px;
    width: 100%;
    border: none;
    outline: none;
    font-family: 'Micrsofot Yahei';
    resize: none;
  }

  .send {
    /*
      原来是 fixed —— 钉在**视口**底部，跟输入框没关系。
      窗口一矮，按钮就爬到 textarea 身上，看起来像"输入框塌了只剩两个图标"。
      .text 本身就是 absolute，拿它当定位父级，按钮才跟着输入框走。
    */
    position: absolute;
    /*
      .text 总高 200 = 图片/表情栏 40 + textarea 110 + 这一行 40，只剩 10 可分。
      原来的 bottom:30 是 fixed 时代随手写的，换成 absolute 后按钮会压住 textarea
      最后一行的右半边 —— 打长文本会被按钮吃掉尾巴。8 是按上面这笔账算出来的。
    */
    bottom: 8px;
    right: 30px;
    span {
      width: 120px;
      height: 40px;
      display: inline-block;
      line-height: 40px;
      box-sizing: border-box;
      text-align: center;
      border-radius: 3px;
      background: #e8e6e6;
      font-size: 20px;
      color: #60b7dc;
      cursor: pointer;
      &.end {
        background: #1596cd;
        color: #fff;
        margin-left: 46px;
      }
    }
  }

  .warn {
    position: absolute;
    bottom: 55px;
    right: 185px;
    width: 110px;
    height: 30px;
    line-height: 30px;
    font-size: 12px;
    text-align: center;
    border: 1px solid #bdbdbd;
    border-radius: 4px;
    box-shadow: 0 1px 5px 1px #bdbdbd;

    &.appear-enter-active,
    &.appear-leave-active {
      transition: all 1s;
    }

    &.appear-enter,
    &.appear-leave-active {
      opacity: 0;
    }

    &:before {
      content: ' ';
      position: absolute;
      top: 100%;
      right: 20px;
      border: 7px solid transparent;
      border-top-color: #fff;
      filter: drop-shadow(1px 3px 2px #bdbdbd);
    }
  }
}
</style>
